export default __webpack_public_path__ + "static/media/cross-platform.5e4cd5ac.svg";